up.compiler('.comment.-done', (element) => {

  element.addEventListener('click', () => {
    up.layer.open({
      mode: 'modal',
      size: 'small',
      content: element.innerHTML,
    })
  })
  element.style.cursor = 'zoom-in'
  element.title = 'Kommentar ist als erledigt gekennzeichnet.\nKlicke, um den Text noch einmal zu lesen.'

})
